/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 3, 2025 at 12:18 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 29, 2025 at 1:10 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const submitQuestion = ({
	question,
	tagId,
	tagSuggestion,
	recaptchaToken,
	submissionEmail
} = {}) => api.post(`${PARSE_MOUNT}/functions/submitQuestionWithParameters`, {
	question,
	tag_id: tagId,
	tag_suggestion: tagSuggestion,
	recaptcha_token: recaptchaToken,
	submission_email: submissionEmail
});

export const fetchQuestion = ({
	questionId,
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchQuestionWithParameters`, {
	question_id: questionId,
});

export const fetchQuestionPreviews = ({
	limit,
	page,
	sortBy,
	tags,
	isFeatured
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchQuestionPreviewsWithParameters`, {
	limit,
	page,
	sort_by: sortBy,
	tags,
	is_featured: isFeatured
});

export const searchQuestions = ({
	searchText,
	urlPath,
	source
} = {}) => api.post(`${PARSE_MOUNT}/functions/searchQuestions`, {
	search_text: searchText,
	url_path: urlPath,
	source
});

export const fetchRelatedQuestions = ({
	questionId,
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchRelatedQuestionsWithParameters`, {
	question_id: questionId
});

export const fetchNextQuestion = ({
	questionId,
	viewedQuestions
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchNextQuestion`, {
	question_id: questionId,
	viewed_questions: viewedQuestions
});

export const fetchRandomQuestion = ({
	questionId,
	viewedQuestions
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchRandomQuestion`, {
	question_id: questionId,
	viewed_questions: viewedQuestions
});

export const recordUpvote = ({
	source,
	entityType,
	entityId,
	urlPath,
} = {}) => api.post(`${PARSE_MOUNT}/functions/recordUpvote`, {
	source,
	entity_type: entityType,
	entity_id: entityId,
	url_path: urlPath,
});

export const removeUpvote = ({
	source,
	entityType,
	entityId,
	urlPath,
} = {}) => api.post(`${PARSE_MOUNT}/functions/removeUpvote`, {
	source,
	entity_type: entityType,
	entity_id: entityId,
	url_path: urlPath,
});
